import { render, staticRenderFns } from "./PaymentInstallmentsType.vue?vue&type=template&id=5ff48d35"
import script from "./PaymentInstallmentsType.vue?vue&type=script&lang=js"
export * from "./PaymentInstallmentsType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports